import { Pipe, PipeTransform } from "@angular/core";
import { ApplicationTheme } from "src/components/shared-components/enum/enumMisc";
import { ThemeService } from "src/service/theme.service";
import { TranslationService } from "src/service/translation.service";

/**
 * Handle generic translation from any keyword
 */
@Pipe({
    name: "supervisionName",
    standalone: false
})
export class SupervisionPipe implements PipeTransform {
  constructor(
    public _translationService: TranslationService,
    public _themeService: ThemeService
  ) { }

  transform(value: any): any {
    let nameSupervision: string = "";
    nameSupervision = value.originalName;

    return this._translationService.TranslateText(nameSupervision);
  }
}
